import UIFlex from 'UIComponents/layout/UIFlex';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UIFilterBar from 'UIComponents/nav/UIFilterBar';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import UICheckbox from 'UIComponents/input/UICheckbox';
import { supportedPublicLanguages } from 'academy-common-lib/constants/academySupportedLanguages';
import UISelect from 'UIComponents/input/UISelect';
import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import { useSearchParams } from '../../../utils/searchParams';
import styled, { theme } from 'academy-common-lib/utils/Styling';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CERTIFICATIONS_ONLY_OPTION, PublicCatalogFilters, FilterNames } from '../publicCatalogConstants';
import AppliedFilters from './PublicCatalogAppliedFilters';
import I18n from 'I18n';
import { useAddFilter, useRemoveFilter, useClearFilter, useToggleFilter, useSetFilter } from '../publicCatalogFiltersHooks';
import { ThemedDropdown, ThemedLinkMixin, ThemedToggle } from '../../../components/ThemedComponents';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PipeDivider = styled.span.withConfig({
  displayName: "PublicCatalogFilters__PipeDivider",
  componentId: "sc-16b7c91-0"
})(["display:inline-block;border-right:2px solid ", ";margin:0 10px 0 20px;height:20px;"], theme.colors.BATTLESHIP);
const StyledSelect = styled(UISelect).withConfig({
  displayName: "PublicCatalogFilters__StyledSelect",
  componentId: "sc-16b7c91-1"
})(["", ""], ThemedLinkMixin);
const CertificationsOnlyToggle = () => {
  var _searchParams$awardTy;
  const [searchParams] = useSearchParams();
  const toggleFilter = useToggleFilter();
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(UIFormLabel, {
      htmlFor: "certifications-only-toggle",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.catalogPage.filters.awardType.options.ONLY_SHOW_CERTIFICATE_COURSES"
      })
    }), /*#__PURE__*/_jsx(ThemedToggle, {
      checked: (_searchParams$awardTy = searchParams.awardType) === null || _searchParams$awardTy === void 0 ? void 0 : _searchParams$awardTy.includes(CERTIFICATIONS_ONLY_OPTION),
      id: "certifications-only-toggle",
      onChange: () => toggleFilter(FilterNames.AWARD_TYPE, CERTIFICATIONS_ONLY_OPTION),
      size: "small"
    })]
  });
};
const CheckboxFilter = ({
  filterName,
  displayText,
  options
}) => {
  const [searchParams] = useSearchParams();
  const removeFilter = useRemoveFilter();
  const addFilter = useAddFilter();
  const clearFilter = useClearFilter();
  const getFilterChangeHandler = (isAllOption, currentOption, isCurrentOptionSelected) => () => {
    if (isAllOption) {
      clearFilter(filterName);
      return;
    }
    if (isCurrentOptionSelected) {
      removeFilter(filterName, currentOption);
      return;
    }
    addFilter(filterName, currentOption);
  };
  return /*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsx(ThemedDropdown, {
      buttonText: displayText,
      buttonUse: "transparent",
      children: /*#__PURE__*/_jsx(UIToggleGroup, {
        name: filterName,
        children: options.map(option => {
          const selectedOptions = searchParams[filterName] || [];
          const isAllOption = option === 'ALL';
          const isNoOptionSelected = selectedOptions.length === 0;
          const isCurrentOptionSelected = selectedOptions.includes(option);
          return /*#__PURE__*/_jsx(UICheckbox, {
            checked: isAllOption ? isNoOptionSelected : isCurrentOptionSelected,
            onChange: getFilterChangeHandler(isAllOption, option, isCurrentOptionSelected),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `academyPublic.catalogPage.filters.${filterName}.options.${option}`
            })
          }, option);
        })
      })
    })
  }, filterName);
};
const LanguageFilter = () => {
  const setFilter = useSetFilter();
  return /*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsx(StyledSelect, {
      buttonUse: "transparent",
      onChange: ({
        target: {
          value: languageValue
        }
      }) => {
        setFilter(FilterNames.LANGUAGE, languageValue);
      },
      options: supportedPublicLanguages.map(language => {
        return {
          text: LanguageNames[language],
          value: language
        };
      }),
      value: I18n.text('academyPublic.catalogPage.filters.language.displayText')
    })
  });
};
const PublicCatalogFiltersComponent = () => {
  return /*#__PURE__*/_jsxs(View, {
    as: "div",
    marginBlockEnd: "1000",
    children: [/*#__PURE__*/_jsx(UIFilterBar, {
      middleSlot: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        wrap: "wrap",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "strong",
          marginInlineEnd: "800",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.catalogPage.filters.filterBy"
          })
        }), /*#__PURE__*/_jsx(CertificationsOnlyToggle, {}), /*#__PURE__*/_jsx(PipeDivider, {}), [FilterNames.LEVEL, FilterNames.DURATION, FilterNames.CONTENT_TYPE].map(filterName => /*#__PURE__*/_jsx(CheckboxFilter, {
          displayText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `academyPublic.catalogPage.filters.${filterName}.displayText`
          }),
          filterName: filterName,
          options: PublicCatalogFilters[filterName]
        }, filterName)), /*#__PURE__*/_jsx(LanguageFilter, {})]
      })
    }), /*#__PURE__*/_jsx(AppliedFilters, {})]
  });
};
export default PublicCatalogFiltersComponent;